export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8110.909978e6.jpg";